/**
 * Verify a reCAPTCHA action against the backend `/captcha-verify` endpoint.
 *
 * Disabled on localhost: returns true without calling reCAPTCHA or hitting `/captcha-verify`. The
 * Vite dev server (:3000) doesn't serve that endpoint (it would 404), and we don't want captcha
 * blocking local development.
 *
 * @param {(action: string) => Promise<string>} executeRecaptcha - `executeRecaptcha` from useGoogleReCaptcha()
 * @param {string} action - reCAPTCHA action name, e.g. "create_brand"
 * @returns {Promise<boolean>} True when verification passed (or was bypassed on localhost)
 */
export async function verifyCaptcha(executeRecaptcha, action) {
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return true;
  }

  if (!executeRecaptcha) {
    return false;
  }

  const token = await executeRecaptcha(action);
  const res = await fetch("/captcha-verify", {
    method: "POST",
    body: JSON.stringify({ recaptcha: { token, action } }),
    headers: { "content-type": "application/json" },
  });
  const data = await res.json();
  return Boolean(data.success);
}
